<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-mb-dialog any-info-dialog">
    <!-- ヘッダー -->
    <v-row class="com-mb-dialog-header any-info-header">
      <div class="com-mb-dialog-title any-info-title text-truncate">
        {{ anyInfo[anyInfoIndex].summary }}
      </div>
      <v-spacer></v-spacer>
      <v-btn small icon class="any-info-header" @click="closeAnyInfoDlg">
        <v-icon>highlight_off</v-icon>
      </v-btn>
    </v-row>
    <!-- コンテンツ -->
    <div class="com-mb-dialog-contents">
      <div class="com-mb-dialog-frame">
        <v-list class="pa-0">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-action-text>
                <span
                  style="white-space: pre-wrap;"
                  v-html="anyInfo[anyInfoIndex].detail"
                ></span>
              </v-list-item-action-text>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </div>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 任意お知らせダイアログ
 * AnyInfoDlg.vue
 * @author LIS
 */
export default {
  /** タグ名 */
  name: "map-any-info-dlg",
  computed: {
    /** 任意お知らせ */
    anyInfo: {
      get() {
        return this.$store.state.info.any;
      },
    },
    /** 任意お知らせ選択中レコード */
    anyInfoIndex: {
      get() {
        return this.$store.state.info.anyInfoIndex;
      },
    },
  },
  methods: {
    /** 任意お知らせダイアログを閉じる */
    closeAnyInfoDlg() {
      this.$store.commit("map/setShowAnyInfoDlg", false);
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../scss/kwb.scss";
@import "./../../scss/color.scss";

.any-info-dialog {
  position: fixed;
  z-index: 3099;
  top: 44px;
  left: 2px;
  right: 2px;
  bottom: 2px;
  .any-info-header {
    background-color: $color-any-info-header-back;
    color: $color-any-info-text;
    .any-info-title {
      width: 85%;
    }
  }
}
</style>
